<app-header (notifyMobileOpen)="getMobileOpenNotification($event)"></app-header>
<div class="mainContainer">
    <app-menu selectedItem="buergschaften" class="menu" [class.open]="mobileMenuOpen"></app-menu>
    <div class="content" [class.closed]="mobileMenuOpen">
        @switch (subPage) {
            @case ('BUERGSCHEIN_LIST') {
                <list-buergschaft></list-buergschaft>
            }
            @case ('SINGLE_BUERGSCHEIN') {
                <single-buergschaft
                    [buergscheinId]="buergscheinId"
                    [vsnr]="vsnr"
                    [vsnrFormatiert]="vsnrFormatiert"
                    [parent]="this"></single-buergschaft>
            }
            @case ('OBLIGO') {
                <obligo></obligo>
            }
            @case ('BUERGSCHAFT_CREATE') {
                <bgsch-create></bgsch-create>
            }
        }
    </div>
</div>
